export enum ShopStateEnum {
    requested,
    published
}
